module.exports = __webpack_public_path__ + "img/txt.ac769498.png";